import { useCodeRepositoriesQuery } from './useCodeRepositoriesQuery';
import { useCodeRepositoriesSearch } from './useCodeRepositoriesSearch';
import { CodeRepository } from '../types';

export const useCodeRepositoryList = (filters: Record<string, string> = {}) => {
    const query = useCodeRepositoriesQuery(filters);
    const { keyword } = useCodeRepositoriesSearch();

    const items = query.data?.pages?.flatMap(page =>
        (page && 'items' in page) ? page.items : []
    ) ?? [];

    const visibleItems = items.filter((item: CodeRepository) =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.provider?.toLowerCase().includes(keyword.toLowerCase())
    );

    const fetchNextPage = () => {
        if (query.hasNextPage) {
            query.fetchNextPage();
        }
    };

    return {
        items,
        visibleItems,
        loading: query.isLoading,
        nextToken: query.hasNextPage ? 'has-more' : null,
        fetchNextPage,
    };
};
